<script setup lang="ts">
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
</script>

<template>
    <div class="content-container">
        <h1>{{ t('privacy.title') }}</h1>

        <section>
            <h2>{{ t('privacy.protection.title') }}</h2>
            <p>{{ t('privacy.protection.content') }}</p>
        </section>

        <section>
            <h2>{{ t('privacy.ads.title') }}</h2>
            <p>{{ t('privacy.ads.content1') }}</p>
            <p>{{ t('privacy.ads.content2') }}</p>
            <p>
                {{ t('privacy.ads.content3_prefix') }}
                <a href="https://policies.google.com/technologies/ads?hl=ja" target="_blank" rel="noopener noreferrer">
                    {{ t('privacy.ads.content3_link_text') }}
                </a>
                {{ t('privacy.ads.content3_suffix') }}
            </p>
        </section>

        <section>
            <h2>{{ t('privacy.analytics.title') }}</h2>
            <p>{{ t('privacy.analytics.content') }}</p>
        </section>

        <section>
            <h2>{{ t('privacy.sns_data.title') }}</h2>
            <p>{{ t('privacy.sns_data.content') }}</p>
        </section>

        <section>
            <h2>{{ t('privacy.disclaimer.title') }}</h2>
            <p>{{ t('privacy.disclaimer.content1') }}</p>
            <p>{{ t('privacy.disclaimer.content2') }}</p>
        </section>

        <section>
            <h2>{{ t('privacy.copyright.title') }}</h2>
            <p>{{ t('privacy.copyright.content') }}</p>
        </section>

        <section>
            <h2>{{ t('privacy.contact.title') }}</h2>
            <p>{{ t('privacy.contact.content') }}</p>
        </section>

        <section class="policy-footer">
            <p>{{ t('privacy.date') }}</p>
            <p>{{ t('privacy.site_name') }}</p>
        </section>

        <router-link to="/" class="back-link">{{ t('common.back') }}</router-link>
    </div>
</template>

<style scoped>
@import '@/assets/text-page.css';

.policy-footer {
    margin-top: 3rem;
    text-align: right;
    font-size: 0.9rem;
    color: #666;
}
</style>
